import { ReactNode, lazy, Suspense } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileCallButton from "./MobileCallButton";
import StickyCTA from "./StickyCTA";
import CookieConsent from "./CookieConsent";

const ExitIntentPopup = lazy(() => import("./ExitIntentPopup"));

const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1 pt-24 sm:pt-36 md:pt-44">{children}</main>
      <Footer />
      <MobileCallButton />
      <StickyCTA />
      <CookieConsent />
      <Suspense fallback={null}>
        <ExitIntentPopup />
      </Suspense>
    </div>
  );
};

export default Layout;
